import { requestUtil } from "../../apis";

export const apiGetLangList = (params: any): any =>
  requestUtil("get", `/api/language`, params, false);
